import React, { useContext } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { errMsg } from './superadmin/ui';
import { ShieldAlert, LogOut } from 'lucide-react';
import { AuthContext } from '../App';

export const ImpersonationBanner = () => {
  const { user } = useContext(AuthContext);
  if (!user?.impersonating) return null;
  const companyName = user.company?.name || user.company_name || 'this company';
  const expires = user.impersonation?.expires_at ? new Date(user.impersonation.expires_at) : null;

  const exit = async () => {
    try {
      await axios.post('/superadmin/impersonation/end');
    } catch (e) {
      toast.error(errMsg(e, 'Could not close the session cleanly'));
    }
    const saToken = localStorage.getItem('superadmin_token');
    if (saToken) {
      localStorage.setItem('token', saToken);
    } else {
      localStorage.removeItem('token');
    }
    localStorage.removeItem('superadmin_token');
    window.location.href = '/superadmin';
  };

  return (
    <div
      data-testid="impersonation-banner"
      role="alert"
      style={{
        position: 'sticky', top: 0, zIndex: 10000, background: '#D90000', color: '#fff',
        padding: '10px 20px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 16,
        fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 14, letterSpacing: '0.01em',
        boxShadow: '0 4px 24px rgba(217,0,0,0.45)', borderBottom: '2px solid #ff5a5a',
      }}
    >
      <ShieldAlert size={20} />
      <span data-testid="impersonation-banner-text">
        You are currently viewing <strong style={{ textDecoration: 'underline' }}>{companyName}</strong> as Super Admin
        {user.impersonation?.reason ? <span style={{ opacity: 0.85 }}> · Reason: {user.impersonation.reason}</span> : null}
        {expires ? <span style={{ opacity: 0.75 }}> · Session ends {expires.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span> : null}
      </span>
      <span style={{ opacity: 0.6 }}>—</span>
      <button
        type="button"
        data-testid="exit-impersonation-btn"
        onClick={exit}
        style={{
          background: '#0A0A0A', color: '#fff', border: '1px solid #fff', padding: '6px 14px', cursor: 'pointer',
          fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', fontSize: 12, display: 'flex', alignItems: 'center', gap: 6,
        }}
      >
        <LogOut size={14} /> Exit Impersonation
      </button>
    </div>
  );
};

export default ImpersonationBanner;
